import React, { Component } from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import ReactDrawer from 'react-drawer';
import { Subscribe } from 'unstated';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import _ from 'lodash';

import { Alert } from 'reactstrap';
import HeaderPage from './HeaderPage';
import JamCard from '../components/JamCard';
import Footer from '../components/Footer';
import ParentJamDetails from '../components/ParentJamDetails';
import JamParentSelectContainer from '../containers/JamParentSelectContainer';


// import mockCardsList from './__mocks__/cardsList.json';

const styles = {
  body: {
    margin: '0 auto',
    width: 'calc(100% - 85px)',
  },
  issueCardWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '1.5625rem',
  },
};

const dataForRandomCard = [
  {
    _id: '1',
    random: true,
    icon: 'icon-dice',
    step: [1, 2],
    title: 'Random Topic',
    blurb: 'Selecting this will randomly select a Topic.',
  },
  {
    _id: '1e',
    random: true,
    icon: 'icon-dice2',
    step: [2],
    title: 'Random Topic',
    blurb: 'Selecting this will randomly select a Topic.',
  },
];

const GraphQueries = {
  'story': templateId => `
    storyByTemplate(templateId: "${templateId}") {
      title,
      blurb,
      _id,
      image, 
      template {
        _id
        name
        slug
      }
    }
  `,
  'storyOne': storyId => `
    storyById(_id: "${storyId}") {
      title,
      blurb,
      _id,
      image, 
      template {
        _id
        name
        slug
      }
    }
  `,
  'templateBySlug': templateSlug => `
    templateBySlug(slug: "${templateSlug}") {
      name, 
      _id,
      slug, 
      blurb, 
      parents {
        type, 
        preset {
          name,
          slug,
          _id
        },
        template {
          name, 
          slug, 
          _id
        }
        count
      },
      sessions {
        description, 
        index,
        _id, 
        output {
          name,
          slug, 
          type
        }
      }
    }
  `,
  'premise': `
    premiseMany {
      _id, 
      title,
      blurb,
      image
    }
  `,
  'topic': `
    topicMany {
      _id, 
      title,
      blurb,
      image
    }
  `,
  'archetype': `
    archetypeMany {
      _id, 
      name,
      blurb,
      image
    }
  `,
  'genre': `
    genreMany {
      _id,
      name, 
      blurb,
      image
    }
  `,
};

function getParentsFromGraphResults(currentRequirement, graphResults) {
  if (['Premise', 'Genre', 'Topic', 'Archetype'].indexOf(currentRequirement.name.trim()) >= 0) {
    return graphResults[`${currentRequirement.name.trim().toLowerCase()}Many`];
  }

  if (currentRequirement.__typename === 'Template') {
    return [graphResults.storyOne]
      .concat(graphResults.storyByTemplate)
      .filter(i => i);
  }

  return [];
}

function Errors(props) {
  return props.errors.map((err, i) => (
    <Alert key={i} color="danger">{err.message}</Alert>
  ));
}


function SelectedJamParentQuery(props) {
  const { template, preselects, jamParent } = props;

  const gqls = template.parents.map((parent) => {
    if (parent.template) {
      return GraphQueries.story(parent.template._id);
    }

    return GraphQueries[parent.preset.slug];
  });

  if (preselects) {
    if (preselects.parents && preselects.parents.length) {
      preselects.parents.forEach(p => gqls.push(GraphQueries.storyOne(p)));
    }
  }

  // props.preselects.parents.map(p => GraphQueries.storyOne(p))

  console.log(gqls);

  const query = `{  
      ${gqls.join('\n')} 
  }`;

  if (!query.length) {
    return null;
  }

  return (
    <Query query={gql(query)}>
      {({ loading, error, data }) => {
        if (loading) return <p>Loading...</p>;

        if (error) return <p>Error :(</p>;
        // if (error) return <CardsList lists={getParentsFromGraphResults(props.currentRequirement, mockCardsList)} />;
        const cardsList = getParentsFromGraphResults(props.currentRequirement, data);
        console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', data, props.currentRequirement, cardsList, jamParent.state);


        return <CardsList preselects={preselects} jamParent={jamParent} lists={cardsList} type={props.currentRequirement.name} />;
      }}
    </Query>
  );
}

class CardsList extends Component {
  componentDidMount() {
    console.log('CardsList:componentDidMount:before', {
      props: this.props,
      state: this.props.jamParent.state,
    });

    if (this.props.preselects.parents.length) {
      console.log('Has preselects');
      if (!_.some(this.props.jamParent.state.selectedParents, { _id: this.props.preselects.parents[0] })) {
        console.log('Adding to jamParent');

        const preselectedParent = _.find(this.props.lists, { _id: this.props.preselects.parents[0] });

        _.assign(preselectedParent, {type: preselectedParent.template.name});


        this.props.jamParent.setState((state) => ({...state, 
            selectedParents: [...state.selectedParents, preselectedParent]
          })).then(() => this.props.jamParent.checkRequirements(preselectedParent))
      }
    }

    console.log('CardsList:componentDidMount:after', {
      props: this.props,
      state: this.props.jamParent.state,
    });
  }


  render() {
    if (!this.props.lists) {
      return null;
    }

    const { lists, type, jamParent } = this.props;

    const icons = [
      'camera',
      'carrot',
      'collapse',
      'cross',
      'delete',
      'expand',
      'eye',
      'filter',
      'heart',
      'hidden',
      'leader',
      'questionmark',
      'search',
      'thumbdown',
      'thumbup',
      'tick',
      'warning',
    ];

    const getRandomCard = () => {
      console.log('lists', lists);
      return lists.filter(card => !card.random)[_.random(lists.length)];
    }

    const randomCards = dataForRandomCard.map((info, randomCardIndex) => Object.assign(info, {
      getRandomCard, random: true, randomCardIndex,
    }));

    // renderRandomCard = jamParent => dataForRandomCard.map((info) => {
    //   if (info.step.indexOf(jamParent.state.currentStep) === -1) {
    //     return null;
    //   }
    //   return (
    //     <JamCard
    //       key={info.id}
    //       _id={info.id}
    //       title={info.title}
    //       blurb={info.blurb}
    //       icon={info.icon}
    //       random={info.random}
    //       step={info.step}
    //     />
    //   );
    // });

    return ([...randomCards, ...lists]).map((info) => {
      // console.log(jamParent.state.currentStep)
      // console.log(info.step)
      if (info.step !== undefined && info.step.indexOf(jamParent.state.currentStep) === -1) {
        return null;
      }
      return (
        <JamCard
          key={info._id}
          _id={info._id}
          title={info.title || info.name}
          type={type}
          blurb={info.blurb}
          image={(info.image) ? info.image : ''}
          random={info.random}
          getRandomCard={getRandomCard}
          step={info.step}
          icon={info.icon ? info.icon : `icon-${_.sample(icons)}`}
          randomCardIndex={info.randomCardIndex}
        />
      );
    });
  }
}

function parsePreselectProps(props) {
  const paramsMap = new URLSearchParams(props.location.search.replace(/\?/g, ''));
  const obj = {
    template: paramsMap.get('template'),
    parents: paramsMap.getAll('parents[]'),
  };

  console.log('SelectJamParentPage:preselect', obj);

  return obj;
}

class SelectJamParentPage extends Component {
  componentDidMount() {
    if (this.props.jamParent) {
      this.props.jamParent.setup(this.props);
    }
  }

  componentWillUnmount() {
    this.props.jamParent.destroy();
  }


  renderJamCardDetails = (cardInfo, openDrawer, random) => {
    const {
      icon, title, blurb, type, image,
    } = cardInfo;
    const label = `${type} Title:`;
    const blurbLabel = `${type} Blurb:`;
    return (
      <div>{(openDrawer && !(random)) ? (<ParentJamDetails type={type} image={image} blurbLabel={blurbLabel} label={label} icon={icon} blurb={blurb} title={title} />) : ''}</div>
    );
  }

  render() {
    const { classes, jamParent, template} = this.props;

    console.log('SelectJamParentPage:before', jamParent.state);

    if (!(jamParent && jamParent.state.currentRequirement)) {
      return (<div />);
    }

    console.log('SelectJamParentPage:after', jamParent.state);

    return (
      <div>
                <div className={(jamParent.state.openDrawer && !(jamParent.state.random)) ? 'drawerWrapper' : ''}>
                  <div className={classes.body}>
                    <HeaderPage titleHeader={`${template.name} Jam`} descriptionHeader={`Select ${jamParent.state.currentRequirement.count} ${jamParent.state.currentRequirement.name}  to continue with the ${template.name} Jam.`} showBtns />

                    <Errors errors={jamParent.state.errors} />
                    <div className={classes.issueCardWrapper}>

                      <SelectedJamParentQuery jamParent={jamParent} preselects={this.props.preselects} template={template} currentRequirement={jamParent.state.currentRequirement} />
                    </div>
                    <ReactDrawer
                      open={jamParent.state.openDrawer}
                      onClose={jamParent.onDrawerClose}
                    >
                      {this.renderJamCardDetails(jamParent.state.cardInfo, jamParent.state.openDrawer, jamParent.state.random)}
                    </ReactDrawer>
                  </div>
                </div>
                {(!(jamParent.state.currentRequirement && jamParent.state.currentRequirement.count)) ? <Footer actionBtnLabel="Continue" backBtnLabel="Back to Recipe" to={`/create/${this.props.match.params.slug}/select/addPrompt`} back="/create" /> : ''}
              </div>
    );
  }
}

function SelectJamParentPageWrapper(props) {
  const { classes } = props;

  return (
    <Subscribe to={[JamParentSelectContainer]}>
      { jamParent => (
        <div>
          { jamParent && (

          <Query query={gql(`{${GraphQueries.templateBySlug(props.match.params.slug)}}`)}>
            {({ loading, error, data }) => {
              if (loading) return <div>Loading...</div>;
              if (error) return <div>Error :(</div>;
              console.log('dataaaaaaaaa', data);
              return (
                <SelectJamParentPage {...props} template={data.templateBySlug} classes={classes} preselects={parsePreselectProps(props)} jamParent={jamParent} />
              );
          }}
            </Query>
          ) }
        </div>
      )}
    </Subscribe>
  );
}
SelectJamParentPageWrapper.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(SelectJamParentPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/SelectJamParentPage.js